import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    Switch,
    HashRouter
  } from "react-router-dom";
import { CRUDTable, CRUDForm, CRUDBlock } from './..';
import { translate } from '../../../Services/translation';

export const CRUDRoute = ({ auth, model }) => {         
    const { forbidEditAction, forbidCreateNew, forbidShowBlockAction, root, item } = model;    
    return (
        <Routes>
            {!forbidEditAction ? <Route path={`/${root}/edit/:id`} 
            element={auth ? <CRUDForm model={model} actionName={translate("coptikk.adminportal.edit") + " " + `${item}`} />: <Navigate to="/"/>
            } /> : null}
            {!forbidShowBlockAction ? <Route path={`/${root}/block/:id`} 
            element={auth ? <CRUDBlock model={model} actionName={translate("coptikk.adminportal.edit.blocks") + " " + `${item}`} /> : <Navigate to="/"/>
            } /> : null}
            {!forbidCreateNew ? <Route path={`/${model.root}/create`} 
            element={auth ? <CRUDForm model={model} actionName={translate("coptikk.adminportal.create") + " " + `${item}`} /> : <Navigate to="/"/>
            } /> : null}
            <Route path={`/${root}`} element={auth ? <CRUDTable model={model} /> : <Navigate to="/"/>
            } />
        </Routes>
    );
}